import './Navigation.css';

const Navigation = () => {
  return (
    <header className="header-container">
      <a
        href="https://www.crystalandco.co.uk"
        target="_blank"
        rel="noopener noreferrer"
        className="header-link"
      >
        Crystal&Co
      </a>
    </header>
  );
};

export default Navigation;
